<template>
  <div class="item" @click="onCourseClick">
    <div class="cover-wrap">
      <img class="cover" :src="course.cover_img" />
    </div>
    <div class="body">
      <div class="title">{{ course.title }}</div>
      <!-- <div class="marketing_language">{{ course.marketing_language }}</div> -->
      <!-- <div class="footer"> -->
      <!-- <router-link
          v-if="teacher"
          class="teacher"
          @click.native.stop
          :to="{
            name: 'ShowTeachersDetaial',
            params: { id: teacher.id },
            query: { route_name: 'ShowTeachers', route_label: '名师' },
          }"
        >
          <div class="teacher">
            <img class="teacher-avatar" :src="teacher.teacher_avatar" />
            <div>
              <div class="teacher-name">{{ teacher.teacher_name }}</div>
              <div class="teacher-advert">{{ teacher.marketing_language }}</div>
            </div>
          </div>
        </router-link> -->
      <div class="bottomBox">
        <div v-if="state == 0" class="user-num">
          {{ course.sales_base + course.sales_num }}人预约
        </div>
        <div class="user-num" v-else>
          {{ course.browse_base + course.browse_num }}人观看
        </div>
        <CurrencyNew :priceUnderline="course.underlined_price"></CurrencyNew>
      </div>
    </div>
    <!-- </div> -->
    <div
      class="state-wrap"
      :class="
        'state-wrap-' + state + ' play-type-' + course.play_type.play_type
      "
    >
      <span class="icon"></span>
      <span v-if="state == 0">{{ timeString }}开始</span>
      <span v-else-if="state == 1">直播中</span>
      <span v-else-if="state == -1">
        {{
          course.bjy_encode_status == 1
            ? "查看回放"
            : course.bjy_encode_status == 2
            ? "已结束(回放生成中)"
            : "已结束"
        }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "RichPublicCourseItem",
  props: {
    course: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    teachers_list() {
      return (this.course.teachers_list || []).splice(0, 1);
    },
    teacher() {
      return (this.course.teachers_list || [])[0];
    },
    state() {
      let tsNow = parseInt(new Date().getTime() / 1000);
      if (tsNow < this.course.start_play_date) {
        return 0;
      } else if (
        tsNow >= this.course.start_play_date &&
        tsNow <= this.course.end_play_date
      ) {
        return 1;
      }
      return -1;
    },
    timeString() {
      let ts = this.course.start_play_date;
      let date = new Date(ts * 1000);
      let dateNow = new Date();
      if (date.getFullYear() > dateNow.getFullYear()) {
        return date.format("yyyy-MM-dd hh:mm");
      }
      let dateStr = date.format("yyyy-MM-dd");
      if (dateStr == dateNow.format("yyyy-MM-dd")) {
        let tsSurplus = ts - parseInt(dateNow.getTime() / 1000);
        if (tsSurplus > 30 * 60) {
          return date.format("hh:mm");
        }
        return parseInt(tsSurplus / 60) + "分钟后";
      }
      dateNow.setDate(dateNow.getDate() + 1);
      if (dateStr == dateNow.format("yyyy-MM-dd")) {
        return "明天" + date.format("hh:mm");
      }
      dateNow.setDate(dateNow.getDate() + 1);
      if (dateStr == dateNow.format("yyyy-MM-dd")) {
        return "后天" + date.format("hh:mm");
      }
      return date.format("MM-dd hh:mm");
    },
  },
  methods: {
    onCourseClick() {
      this.$router.push({
        name: "CourseShow",
        params: {
          id: this.course.id,
        },
        query: {
          nav: this.$route.query.nav,
          recommend: 3,
          title: "公开课",
        },
      });
      // this.$livePlay(this.course.id, this.course.course_type, {
      //   id: 0,
      //   title: this.course.title,
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  position: relative;
  width: 282px;
  height: 298px;
  background: white;
  // border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 8px;
  float: left;
  margin-right: 24px;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  &:nth-child(4n) {
    margin-right: 0;
  }
  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);

    .cover {
      transform: scale(1.1);
    }
  }
}
.cover-wrap {
  height: 188px;
  border-radius: 8px 8px 0 0;
  margin-bottom: 16px;
  overflow: hidden;
}
.cover {
  width: 100%;
  height: 100%;
  border-radius: 8px 8px 0 0;
  display: block;
  transform: scale(1);
  transition: 0.3s all;
}
.body {
  margin: 0 16px;
}
.title {
  max-height: 52px;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 26px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 13px;
}
.marketing_language {
  height: 17px;
  font-size: 16px;
  color: #999999;
  line-height: 17px;
}
.time {
  font-size: 16px;
  color: $primary-color;
  line-height: 1;
  margin-bottom: 15px;
}
.footer {
  padding-bottom: 26px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 0 21px;
  left: 0;
  bottom: 26px;

  /deep/ {
    .price-wrap {
      margin-bottom: 7px;
    }
    .price-underline {
      margin-right: 12px;
      margin-top: 0;
    }
  }
}
.teacher {
  display: flex;
  align-items: center;
  height: 36px;
}
.teacher-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 10px;
  border: 1px solid #fff;
}
.teacher-name {
  height: 14px;
  font-size: 14px;
  color: #333333;
  line-height: 1;
  margin-bottom: 8px;
}
.teacher-advert {
  height: 14px;
  font-size: 14px;
  color: #999999;
  line-height: 1;
}
.bottomBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  bottom: 16px;
  position: absolute;
  width: 250px;
}
.user-num {
  height: 13px;
  font-size: 13px;
  color: #999999;
  line-height: 1;
  text-align: right;
}
.state-wrap {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 26px;
  line-height: 26px;
  border-radius: 6px 0px 10px 0px;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: white;
}
.state-wrap-0 {
  background: $primary-color;
  padding: 0 8px;

  // .icon {
  //   width: 6px;
  //   height: 6px;
  //   background: white;
  //   border-radius: 3px;
  //   margin-right: 8px;
  // }
}
.state-wrap-1 {
  background: #ff2424;
  padding: 0 8px;

  .icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    background-image: url("~@/assets/images/course/live.gif");
    background-size: 100% 100%;
  }
}
.state-wrap--1 {
  background: rgba(0, 0, 0, 0.5);
  padding: 0 8px;
  &.play-type-0 {
    .icon {
      width: 14px;
      height: 14px;
      margin-right: 6px;
      background-image: url("~@/assets/images/course/play.png");
      background-size: 100% 100%;
    }
  }
  &.play-type-4 {
    .icon {
      width: 14px;
      height: 14px;
      margin-right: 6px;
      background-image: url("~@/assets/images/course/play@2x.png");
      background-size: 100% 100%;
    }
  }

  &.play-type-5,
  &.play-type-3 {
    background: rgba(0, 0, 0, 0.5);

    .icon {
      width: 14px;
      height: 14px;
      margin-right: 6px;
      background-image: url("~@/assets/images/course/live-none@2x.png");
      background-size: 100% 100%;
    }
  }
}
</style>
